import React from 'react';
import Icon from "./Icon";

const IconAirCondition = ({tooltip}) => {
    return (
        <Icon image="/img/icons/icon-snow.svg" tooltip={tooltip}/>
    )
};

export default IconAirCondition;